var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-spin",
    { attrs: { spinning: _vm.confirmLoading } },
    [
      _c(
        "j-form-container",
        { attrs: { disabled: _vm.formDisabled } },
        [
          _c(
            "a-form-model",
            {
              ref: "form",
              attrs: {
                slot: "detail",
                model: _vm.model,
                rules: _vm.validatorRules
              },
              slot: "detail"
            },
            [
              _c(
                "a-row",
                [
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["gift_vendor_code"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              placeholder: _vm.language["rectify.sys.create"],
                              disabled: ""
                            },
                            model: {
                              value: _vm.model.code,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "code", $$v)
                              },
                              expression: "model.code"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["gift_user_app"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "app"
                          }
                        },
                        [
                          _c(
                            "a-select",
                            {
                              attrs: {
                                disabled: _vm.isDisabled,
                                placeholder:
                                  _vm.language["column.pleaseChoose"] +
                                  _vm.language["ipsys.eventName"]
                              },
                              model: {
                                value: _vm.model.appId,
                                callback: function($$v) {
                                  _vm.$set(_vm.model, "appId", $$v)
                                },
                                expression: "model.appId"
                              }
                            },
                            _vm._l(_vm.appDataMap, function(v, k) {
                              return _c(
                                "a-select-option",
                                { key: k, attrs: { value: k, label: v } },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(v) +
                                      "\n                "
                                  )
                                ]
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["gift_vendor_name"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "name"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              placeholder:
                                _vm.language["common.pleaseInput"] +
                                _vm.language["gift_vendor_name"],
                              disabled: _vm.isDisabled
                            },
                            model: {
                              value: _vm.model.name,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.model,
                                  "name",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "model.name"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["construct.contactPerson"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "contact"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              placeholder:
                                _vm.language["common.pleaseInput"] +
                                _vm.language["construct.contactPerson"]
                            },
                            model: {
                              value: _vm.model.contact,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "contact", $$v)
                              },
                              expression: "model.contact"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["ipsys.contact_no"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "phone"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              placeholder:
                                _vm.language["common.pleaseInput"] +
                                _vm.language["ipsys.contact_no"]
                            },
                            model: {
                              value: _vm.model.phone,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "phone", $$v)
                              },
                              expression: "model.phone"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["gift_vendor_address"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "address"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              placeholder:
                                _vm.language["common.pleaseInput"] +
                                _vm.language["gift_vendor_address"]
                            },
                            model: {
                              value: _vm.model.address,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "address", $$v)
                              },
                              expression: "model.address"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["gift_vendor_logo"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "logo"
                          }
                        },
                        [
                          _c("j-image-upload", {
                            staticClass: "avatar-uploader",
                            attrs: {
                              text: _vm.language["common.uploadButton"],
                              "upload-source": _vm.uploadSource,
                              isMultiple: false,
                              maxSize: 200,
                              disabled: _vm.disableSubmit
                            },
                            model: {
                              value: _vm.model.logo,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "logo", $$v)
                              },
                              expression: "model.logo"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["gift_vendor_license"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "businessLicense"
                          }
                        },
                        [
                          _c("j-image-upload", {
                            staticClass: "avatar-uploader",
                            attrs: {
                              text: _vm.language["common.uploadButton"],
                              "upload-source": _vm.uploadSource,
                              isMultiple: false,
                              maxSize: 200,
                              disabled: _vm.disableSubmit
                            },
                            model: {
                              value: _vm.model.businessLicense,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "businessLicense", $$v)
                              },
                              expression: "model.businessLicense"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["gift_vendor_story"],
                            labelCol: _vm.labelCol3,
                            wrapperCol: _vm.wrapperCol3,
                            prop: "story"
                          }
                        },
                        [
                          _c("j-editor", {
                            staticStyle: { "margin-left": "10px" },
                            attrs: {
                              disabled: _vm.disableSubmit,
                              plugins: _vm.JEitorPlugins
                            },
                            model: {
                              value: _vm.model.story,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "story", $$v)
                              },
                              expression: "model.story"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }